import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TransactionDetails, TransationInfoPayload } from '@models/Transaction';
import { APIResponse } from '@/api/models/Invoice';

// Define the state type
export interface TransactionState {
  loading: boolean;
  success: boolean;
  error: boolean;
  transactionDetails: TransactionDetails['data'] | null;
  errorMessage: string | null;
}

// Initial state
const initialState: TransactionState = {
  loading: false,
  success: false,
  error: false,
  transactionDetails: null,
  errorMessage: null,
};

// Create a slice
const transactionSlice = createSlice({
  name: 'transaction',
  initialState,
  reducers: {
    // Actions to fetch invoice data
    fetchTransactionInfoStart(state, __action: PayloadAction<TransationInfoPayload>) {
      state.loading = true;
      state.error = false;
    },

    fetchTransactionInfoSuccess(state, action: PayloadAction<APIResponse<TransactionDetails>>) {
      state.loading = false;
      state.success = true;
      state.transactionDetails = action.payload.data?.data || null;
    },

    fetchTransactionInfoFailure(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.payload;
      state.transactionDetails = null;
    },
  },
});

// Export actions
export const {
  fetchTransactionInfoStart,
  fetchTransactionInfoSuccess,
  fetchTransactionInfoFailure,
} = transactionSlice.actions;

// Export reducer to be added to the store
export default transactionSlice.reducer;
